import {
    BoldText,
    CardContent,
    FeedbackCTA,
    FeedbackCardContainer,
    FeedbackContentWrapper,
    FeedbackIconWrapper,
    FeedbackTitleWrapper,
    StyledIcon,
} from "./StyledComponents";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { colorsPalettes } from "@similarweb/styles";
import type { IQuestion } from "pro-features/components/Modals/src/FeedbackSurveyModal";
import { FeedbackSurveyModal } from "pro-features/components/Modals/src/FeedbackSurveyModal";
import { useState } from "react";
import AllContexts from "pro-features/pages/workspace/common components/AllContexts";
import { InsightsFeedbackQuestions } from "app/pages/website-analysis/traffic-sources/mmx/components/InsightsAssistant/InsightsFeedbackQuestions";
import { showSuccessToast } from "app/actions/toast_actions";
import { connect } from "react-redux";
import { i18nFilter } from "app/filters/i18nFilter";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

const INSIGHTS_FEEDBACK_NAME = "Insights Feedback";

const FeedbackCard = ({ showToast, isCompare }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [votingQuestion, setVotingQuestion] = useState();

    const onSubmitFeedbackModal = async (question: IQuestion, answer) => {
        await PreferencesService.add({
            [INSIGHTS_FEEDBACK_NAME]: {
                votingQuestion: "voting question",
                votingAnswer: votingQuestion,
                textQuestion: "text question",
                textAnswer: answer,
            },
        });
        setIsModalOpen(false);
        showToast(i18nFilter()("mmx.insights.toast"));
    };

    const onNextFeedbackModal = async (question: IQuestion, answer) => {
        setVotingQuestion(answer);
    };

    const onCardClick = () => {
        setIsModalOpen(true);

        allTrackers.dispatchTrackEvent("Button", "click", "Over Time Graph/Channel Analysis/Insights/Feedback");
    };

    return (
        <>
            <FeedbackCardContainer
                onClick={onCardClick}
                isCompare={isCompare}
            >
                <CardContent>
                    <FeedbackTitleWrapper>
                        <FeedbackIconWrapper>
                            <StyledIcon
                                size="sm"
                                iconName={"response"}
                                fill={colorsPalettes.blue["400"]}
                            />
                        </FeedbackIconWrapper>
                        <BoldText>
                            <I18n>mmx.insights.feedback.title</I18n>
                        </BoldText>
                    </FeedbackTitleWrapper>
                    <FeedbackContentWrapper>
                        <I18n>mmx.insights.feedback.subtitle</I18n>
                    </FeedbackContentWrapper>
                </CardContent>
                <FeedbackCTA isCompare={isCompare}>
                    <I18n>mmx.insights.feedback</I18n>
                </FeedbackCTA>
            </FeedbackCardContainer>
            <AllContexts linkFn={proNavigator.href.bind(proNavigator)}>
                <FeedbackSurveyModal
                    isOpen={isModalOpen}
                    onCloseClick={() => setIsModalOpen(false)}
                    onSubmitClick={onSubmitFeedbackModal}
                    onNextClick={onNextFeedbackModal}
                    surveyQuestions={InsightsFeedbackQuestions}
                />
            </AllContexts>
        </>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        showToast: (text?: string) => dispatch(showSuccessToast(text)),
    };
}

export default connect(null, mapDispatchToProps)(FeedbackCard);
